import { useQuoteBuilderView } from '@paradigm/features/src/unified-rfqs/ui/grfq/quote-builder/view';
import BaseLegsTable from '#/components/UnifiedRfqs/components/LegsTable';

function LegsTable() {
  const { legs, side } = useQuoteBuilderView();
  return <BaseLegsTable showContractTerms side={side} legs={legs} />;
}

export default LegsTable;
